module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "pl-0": "",
      "pr-0": ""
    }
  }, [_c('v-form', {
    ref: "splitSegmentForm"
  }, [(_vm.showSplitSegment) ? _c('v-row', {
    staticClass: "justify-center"
  }, [_c('v-col', {
    attrs: {
      "cols": "8",
      "md": "6"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "blue-grey darken-1",
      "dense": "",
      "dark": ""
    },
    on: {
      "click": _vm.splitSegment
    }
  }, [_vm._v("\n          Split Segment\n        ")])], 1)], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.segmentSplit), function(split, index) {
    return _c('v-row', {
      key: index
    }, [_c('v-col', {
      attrs: {
        "cols": "12",
        "md": "9"
      }
    }, [_c('target-name', {
      attrs: {
        "splitSegmentName": true
      },
      on: {
        "updateName": function (val) { return (split.name = val); },
        "updateNameIsValid": function (val) { return _vm.updateSplitNameValid(index, val); }
      }
    })], 1), _vm._v(" "), _c('v-col', {
      staticClass: "pl-0 pr-0",
      attrs: {
        "cols": "6",
        "md": "2"
      }
    }, [_c('v-text-field', {
      attrs: {
        "label": "Split",
        "type": "number",
        "suffix": "%",
        "dense": "",
        "hide-details": "true"
      },
      on: {
        "input": _vm.calculateTotal
      },
      model: {
        value: (split.percentage),
        callback: function($$v) {
          _vm.$set(split, "percentage", $$v)
        },
        expression: "split.percentage"
      }
    })], 1), _vm._v(" "), _c('v-col', {
      staticClass: "pl-0 pr-0",
      attrs: {
        "cols": "12",
        "md": "1"
      }
    }, [_c('v-btn', {
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.removeSplit(index)
        }
      }
    }, [_c('v-icon', [_vm._v("mdi-trash-can-outline")])], 1)], 1)], 1)
  }), _vm._v(" "), (!_vm.showSplitSegment) ? _c('v-row', {
    attrs: {
      "justify": "end"
    }
  }, [_c('v-alert', {
    attrs: {
      "type": _vm.alert.type,
      "dense": "",
      "text": ""
    }
  }, [_vm._v("\n        " + _vm._s(_vm.alert.message))])], 1) : _vm._e(), _vm._v(" "), (!_vm.showSplitSegment) ? _c('v-row', {
    staticClass: "mt-0"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "dense": "",
      "text": "",
      "disabled": _vm.totalPercentage >= 100
    },
    on: {
      "click": _vm.addSplit
    }
  }, [_c('v-icon', [_vm._v("mdi-plus-box-outline")]), _vm._v("\n          Add Split\n        ")], 1)], 1)], 1) : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-338d8716"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/targets/createTarget/components/SegmentSplit.vue
// module id = 1854
// module chunks = 0